import { Box } from '@skin-seoul/design-system';
import { CountryChangeButton } from '@skin-seoul/shared-components';
import type { Currency } from '@skin-seoul/service';
import { Country, CurrencyCountry, CURRENCY_KEY, COUNTRY_KEY } from '@skin-seoul/service';
import { useState, useCallback } from 'react';
import Cookies from 'js-cookie';

interface CountryChangeShortcodeProps {
  initialCountry?: Country;
}

const DEFAULT_COUNTRY = Country.Singapore;

const CountryChangeShortcode = ({ initialCountry }: CountryChangeShortcodeProps) => {
  const getInitialCountry = useCallback((): Country => {
    if (initialCountry) {
      return initialCountry;
    }

    if (typeof window !== 'undefined') {
      const savedCountry = Cookies.get(COUNTRY_KEY) as Country | undefined;
      if (savedCountry && Object.values(Country).includes(savedCountry)) {
        return savedCountry;
      }

      const savedCurrency = Cookies.get(CURRENCY_KEY) as Currency | undefined;
      if (savedCurrency && CurrencyCountry[savedCurrency]) {
        return CurrencyCountry[savedCurrency];
      }
    }

    return DEFAULT_COUNTRY;
  }, [initialCountry]);

  const [currentCountry, setCurrentCountry] = useState<Country>(getInitialCountry);

  const handleCountryChange = (newCountry: Country) => {
    setCurrentCountry(newCountry);
  };

  return (
    <Box width="100%" display="flex" justifyContent="center" alignItems="center" boxSizing="border-box" padding={2}>
      <CountryChangeButton country={currentCountry} onCountryChange={handleCountryChange} />
    </Box>
  );
};

export default CountryChangeShortcode;
